// frontend/src/components/root.jsx
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./app";

import { onSessionExpired } from "../util/auth_events";
import SessionExpiredModal from "./session/SessionExpiredModal";

const Root = ({ store }) => {
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);

  useEffect(() => {
    const off = onSessionExpired(() => {
      setSessionExpiredOpen(true);
    });
    return off;
  }, []);

  return (
    <Provider store={store}>
      <HashRouter>
        <App />

  
      </HashRouter>
    </Provider>
  );
};

export default Root;
